import React from "react";
import '../what_we_do/Technology/tech.css';

const HydroVerra = () => {
    return (
       <>
                   <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif',  backgroundSize: 'cover', backgroundPosition: 'center', color: 'black' }}>
                       <h1>Our HydroVerra Project</h1>
                   </div>
                   <div className='info'>


<h2>HydroVerra Project:<br/></h2>

<p style={{textAlign:'justify', textJustify:'inter-word'}}>We began by conducting a survey across rural and island communities in Scotland, which confirmed the urgent need for reliable, off-grid EV charging solutions. These findings validated our vision for HydroVerra and shaped the design priorities of the system.

Today, we are advancing through research and development, with work underway on our first prototype - a modular, hydrogen-powered charging unit that can deliver ultra-fast, zero-emission charging in places the grid cannot reach.

Alongside the hardware, we are developing an AI-powered optimisation platform that manages the entire HydroVerra system - from hydrogen production and storage, to electricity generation and EV charging. This intelligence layer will ensure maximum efficiency, predictive maintenance, and system reliability, making HydroVerra not just clean and mobile, but also smart and future-proof.</p>
                   </div>
               </>
    );
};

export default HydroVerra;
    